import { useMutation, useQueryClient } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'

interface TogglePartnerIntegrationParams {
  organizationId: string
  userOrganizationId: string
  enabled: boolean
}

const togglePartnerIntegration = async ({
  organizationId,
  userOrganizationId,
  enabled,
}: TogglePartnerIntegrationParams) => {
  const response = await fetch(
    `${BASE_API_URL}/admin/api/v2/organizations/${organizationId}/user_organizations/${userOrganizationId}/partner_integration`,
    {
      method: API_METHODS.PUT,
      headers: apiHeaders(store.getState()),
      body: JSON.stringify({ enabled }),
    }
  )

  if (!response.ok) {
    const errorData = await response.json()
    const errorMessage =
      errorData.error?.message || 'Failed to update partner integration status'
    throw new Error(errorMessage)
  }

  return response.json()
}

export function useTogglePartnerIntegration() {
  const queryClient = useQueryClient()

  return useMutation(togglePartnerIntegration, {
    onSuccess: () => {
      queryClient.invalidateQueries(['organization-users'])
      queryClient.invalidateQueries(['partner-integration'])
    },
  })
}
